import { memo } from 'react'
import { Text } from '@/components'
import { warningBoxStyles as styles } from './WarningBox.style'
import { WarningBoxProps } from './WarningBox.types'

function WarningBox({ children, sx, ...textProps }: WarningBoxProps) {
  return (
    <Text sx={[styles.warning, ...(Array.isArray(sx) ? sx : [sx])]} {...textProps}>
      {children}
    </Text>
  )
}

export default memo(WarningBox)
